<div *ngIf="selectedSponsorInformation">
  <div class="inner-margin-top pos-rel">
    <div class="sponsor-img-set">
      <img
        [src]="selectedSponsorInformation?.imgSrc"
        alt="{{ selectedSponsorInformation.donarInfo.firstName }}
      {{ selectedSponsorInformation.donarInfo.lastName }}"
      />
      <div class="sponsor-amount">
        <div class="sponsor-amount-txt">Donated Amount</div>
        <div class="sponsor-amount-price">
          {{
            selectedSponsorInformation.donarInfo.amount
              | currency : "INR" : "symbol" : "1.0-0"
          }}/-
        </div>
        <div class="sponsor-amount-words">
          ({{ selectedSponsorInformation.donarInfo.amountText }})
        </div>
      </div>
    </div>
    <div class="sponsor-name">
      {{ selectedSponsorInformation.donarInfo.firstName }}
      <!-- {{ selectedSponsorInformation.donarInfo.lastName }} -->
    </div>
    <img src="assets/images/platinum.png" class="sponsor-badge" />
    <img src="assets/images/sponsor-bg.jpg" />
  </div>
  <div class="container-fluid container-w">
    <div class="container flex-end">
      <div class="all-projects-arrow-set" onclick="history.back()">
        <img src="assets/images/back-arrow.svg" />
        <div>Sponsors</div>
      </div>
    </div>

    <div class="container inner-page-content">
      <h3>
        {{ selectedSponsorInformation?.donarInfo?.firstName }}
        <!-- {{ selectedSponsorInformation?.donarInfo?.lastName }}  -->
        Generous
        Contribution to Empower Program in his Village
      </h3>
      <p>{{ selectedSponsorInformation?.donarInfo?.description }}</p>
    </div>

    <div class="container">
      <h3 class="donated">
        Sponsored Project and Amount Details:
        <span
          >{{
            selectedSponsorInformation.donarInfo.amount
              | currency : "INR" : "symbol" : "1.0-0"
          }}/-</span
        >
      </h3>
      <table id="customers">
        <tr>
          <th>Project Name</th>
          <th>Amount</th>
          <th>Location</th>
        </tr>
        <tr *ngFor="let project of selectedSponsorInformation.projectsInfo">
          <td>{{ project.projectType }}</td>
          <td>{{ project.amount }}</td>
          <td>
            {{ project.villageName }} | {{ project.mandalName }} |
            {{ project.districtName }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>

<div class="ep-footer">
  <div class="container">
    <div class="d-flex jusify-space-between">
      <div class="d-flex flex-column">
        <h3>Help</h3>
        <div style="line-height: 20px">
          <div>+91 9288227228</div>
          <div>
            <a href="mailto:info&#64;empowerandhra.com" class="link"
              >info&#64;empowerandhra.com</a
            >
          </div>
        </div>
      </div>
      <div class="d-flex flex-column follow-us-img">
        <h3>Follow us</h3>
        <div class="d-flex gap-3">
          <img src="assets/images/icon-whatsapp.png" />
          <img src="assets/images/icon-facebook.png" />
          <img src="assets/images/icon-instagram.png" />
          <img src="assets/images/icon-twitter.png" />
          <img src="assets/images/icon-youtube.png" />
        </div>
      </div>
    </div>
    <hr />
    <div class="d-flex jusify-space-between">
      <div class="d-flex footer-copyrights">
        <div>2025 © Empower Andhra</div>
        <div><a href="#">Terms of Service</a></div>
        <div><a href="#">Privacy Policy</a></div>
      </div>
      <div>Site last updated on: 12-APR-2025</div>
    </div>
  </div>
</div>
